// src/OtpInput.js
import React, { useState } from "react";
import "./OnboardingOTP.modules.css"; // Import CSS for styling
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import i18next from "i18next";
import { useLocation, useHistory } from "react-router-dom";
import * as Constants from "../../../constants/Constants";

import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";
import { groupIdSignal } from "../OnboardingHome/OnboardingHome";

const OnboardingOTP = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const ReqID = location.state || null;
  const [otp, setOtp] = useState(Array(5).fill(""));
  const [otpEmail, setOtpEmail] = useState(Array(5).fill(""));
  const [redirect, setRedirect] = useState(null);
  console.log("groupIdSignal", groupIdSignal);
  const history = useHistory();
  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = otp.map((digit, i) => (i === index ? value : digit));
      setOtp(newOtp);

      // Move to next input if current input is filled
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Move to previous input if current input is empty and not the first input
      if (!value && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handleChangeotpEmail = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = otpEmail.map((digit, i) => (i === index ? value : digit));
      setOtpEmail(newOtp);

      // Move to next input if current input is filled
      if (value && index < otpEmail.length - 1) {
        document.getElementById(`otpEmail-input-${index + 1}`).focus();
      }

      // Move to previous input if current input is empty and not the first input
      if (!value && index > 0) {
        document.getElementById(`otpEmail-input-${index - 1}`).focus();
      }
    }
  };
  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingLogin);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateSubmit()) return;
    LoginByUsrKYCAPI();
  };
  const validateSubmit = () => {
    ;
    if (
      otpEmail[0] === "" ||
      otpEmail[1] === "" ||
      otpEmail[2] === "" ||
      otpEmail[3] === "" ||
      otpEmail[4] === ""
    ) {
      Helpers.errorNotify(t("tokenSent"), i18next.language);
      return false;
    }
    if (
      otp[0] === "" ||
      otp[1] === "" ||
      otp[2] === "" ||
      otp[3] === "" ||
      otp[4] === ""
    ) {
      Helpers.errorNotify(t("tokenSent"), i18next.language);
      return false;
    }
    return true;
  };

  const SubmitPopUPconfirm = () => {
    var dir = "ltr";
    if (i18next.language == "ar") {
      dir = "rtl";
    }
    confirmAlert({
      overlayClassName: "custom-no-close-overlay",
      customUI: ({ onClose }) => {
        return (
          <div
            className={
              "custom-popup custom-scrollable Onboarding-SubmitPopup " +
              localStorage.getItem(
                Constants.localStorageConstants.company_name
              ) +
              "-CSS"
            }
            style={{ direction: dir, width: "650px", height: "300px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="custom-popup-body pt-2 pb-2">
              <label>{t("Onboarding-MSGLogin")}</label>
              <div className="mt-3 mb-2" style={{ textAlign: "center" }}>
                <button
                  className="btn custom-btn-cancel"
                  onClick={() => {
                    onClose();
                    history.push(AppUrls.login);
                  }}
                >
                  {t("ok")}
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  const LoginByUsrKYCAPI = async () => {
    ;
    try {
      const params = {
        OTP: otp[0] + otp[1] + otp[2] + otp[3] + otp[4],
        Email_OTP:
          otpEmail[0] + otpEmail[1] + otpEmail[2] + otpEmail[3] + otpEmail[4],
        Request_Id:
          ReqID?.ReqID == null ? localStorage.getItem("RID") : ReqID.ReqID,
      };
      var response = utils.LoginByUsrKYCAPI(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "Success") {
            ;
            // AccessToken
            localStorage.setItem("AccT", response.data.AccessToken);

            GetOnboardingData();
            if (groupIdSignal) {
              if (groupIdSignal.value === "Personal") {
                setRedirect(AppUrls.onboardingPersonal);
              } else if (groupIdSignal.value === "Corporate") {
                setRedirect(AppUrls.onboardingCorporate);
              } else if (groupIdSignal.value === "Minor") {
                setRedirect(AppUrls.onboardingPersonal);
              }
            }

            // setRedirect(AppUrls.CustomerInfo);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("LoginByUsrKYCAPI", error);
        });
    } catch (error) {
      console.log("LoginByUsrKYC", error);
    }
  };

  const GetOnboardingData = async () => {
    ;
    try {
      const params = {
        reqID: ReqID?.ReqID == null ? localStorage.getItem("RID") : ReqID.ReqID,
      };
      var response = utils.GetOnboardingData(params);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            ;

            // if (groupIdSignal) {
            //   if (groupIdSignal.value === "Personal") {
            //     setRedirect(AppUrls.onboardingPersonal);
            //   } else if (groupIdSignal.value === "Corporate") {
            //     setRedirect(AppUrls.onboardingCorporate);
            //   } else if (groupIdSignal.value === "Minor") {
            //     setRedirect(AppUrls.onboardingPersonal);
            //   }
            // }

            // setRedirect(AppUrls.CustomerInfo);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else if (response.data.Error_code === "4") {
            SubmitPopUPconfirm();
          } else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("GetOnboardingData", error);
        });
    } catch (error) {
      console.log("GetOnboardingData", error);
    }
  };
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs"> {t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="otp-container">
          <div className="otp-form">
            <h2 style={{ marginBottom: "2rem" }}> {t("VerifyOTP")}</h2>

            <label>{t("enterEmailcode")} </label>
            <div className="otp-inputs mt-2">
              {otpEmail.map((_, index) => (
                <input
                  key={index}
                  id={`otpEmail-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={otpEmail[index]}
                  onChange={(e) => handleChangeotpEmail(e, index)}
                  className="otp-input"
                />
              ))}
            </div>

            <label>{t("OTPDec")} </label>
            <div className="otp-inputs mt-2">
              {otp.map((_, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={otp[index]}
                  onChange={(e) => handleChange(e, index)}
                  className="otp-input"
                />
              ))}
            </div>
            <button
              type="submit"
              className="submit-button"
              onClick={handleSubmit}
            >
              {t("sendOtp")}
            </button>
            <div>
              {/* <button
                className={"link"}
                style={{
                  width: "100%",
                  textDecoration: "underline",
                  marginTop: "1rem",
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleBack}>
                {t("cancelForgotPassword")}
              </button> */}
              {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingOTP;
